import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-healthinsurances',
  templateUrl: './healthinsurances.component.html',
  styleUrls: ['./healthinsurances.component.scss']
})
export class HealthinsurancesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
